<template>
  <v-container class="EagleSubmenu">

    <div style="padding: 10px;" >

      <a  style="text-decoration: none;" href="https://liff.line.me/1657310441-3AN05Gzj" target="_blank">

        <v-card
            v-ripple
            class="mx-auto py-2"
            elevation="4"
            style="border-radius: 10px;"
          

        >
            <v-list-tile class="grow">
              <v-list-tile-avatar >
                <v-img  :src="require(`@/assets/img/eagle_eye_logo.jpg`)"  ></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content >
                 <span class="title font-weight-bold text-wrap " >
                  ข้อเสนอแนะจากพนักงาน
                </span>
              </v-list-tile-content>
            </v-list-tile>
       

        </v-card>

      </a>

    </div>

    <div style="padding: 10px;" >

      <a  style="text-decoration: none;" href="https://portal.chatcone.com/" target="_blank">

        <v-card
            v-ripple
            class="mx-auto py-2"
            elevation="4"
            style="border-radius: 10px;"
        >
            <v-list-tile class="grow">
              <v-list-tile-avatar tile>
                <v-img  :src="require(`@/assets/img/ic-admin.png`)"  ></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <span class="title font-weight-bold text-wrap " >
                 ตอบกลับพนักงาน
                </span>
              </v-list-tile-content>
            </v-list-tile>

        </v-card>

      </a>

    </div>

  </v-container>
</template>

<script>
import EventBus from '@/EventBus'
export default {
  name: "EagleSubmenu",
  mounted() {
    EventBus.$emit('set_navigation', {title: 'Eagle Eye',back_route: 'home'});

  }
}
</script>

<style scoped>
.hide-div{
  display: none;
}

.div-sub-menu{
  margin-left: 20px;
}



</style>